import React, { useCallback, useEffect, useRef } from 'react';
import c from 'classnames';

import useToggle from '@lyearn/core/hooks/useToggle';
import { useNodePerformanceContext, useReactNodeView } from '@lyearn/lygo-core';
import { Box, Stack } from '@lyearn/ui';

import useSetSelection from '../../../../../hooks/useSetSelection';
import FlashCard from '../Card';
import { flashCardContainerStyles, transFormStyles, zIndexStyles } from './styles';
import { FlashCardContainerProps } from './types';

const FlashCardContainer: React.FC<FlashCardContainerProps> = (props) => {
  const { card, type, readOnly } = props;
  const [side, { toggle }] = useToggle(true);
  const flashCardContainerRef = useRef<HTMLDivElement>(null);
  const { setNodePerformance } = useNodePerformanceContext();
  const { node } = useReactNodeView();

  const { selectCurrentNode } = useSetSelection();

  const focusContainer = useCallback(() => {
    if (!readOnly) {
      const flashCardInput = flashCardContainerRef.current?.querySelector(
        side ? '.flashcard-front textarea' : '.flashcard-back textarea',
      );
      (flashCardInput as HTMLElement)?.focus();
    }
  }, [readOnly, side]);

  const frontFlipButtonClick = useCallback(() => {
    toggle();
    if (readOnly) {
      setNodePerformance?.({ id: node?.attrs.id, blockType: 'flash_card', progress: 100 });
    }
  }, [node?.attrs.id, readOnly, setNodePerformance, toggle]);

  useEffect(() => {
    focusContainer();
  }, [focusContainer]);

  return (
    <Stack
      ref={flashCardContainerRef}
      className={c(flashCardContainerStyles, side ? '' : transFormStyles, 'my-56')}
      justifyContent="center">
      <Box className="flip-card" onClick={selectCurrentNode}>
        <Box className="flip-card-inner">
          <Box className={c('flip-card-front', zIndexStyles(side ? 2 : 1))}>
            <FlashCard
              card={card}
              className="flashcard-front"
              readOnly={readOnly}
              side="front"
              toggleCard={frontFlipButtonClick}
              type={type}
            />
          </Box>
          <Box className={c('flip-card-back', zIndexStyles(side ? 1 : 2))}>
            <FlashCard
              card={card}
              className="flashcard-back"
              readOnly={readOnly}
              side="back"
              toggleCard={toggle}
              type={type}
            />
          </Box>
        </Box>
      </Box>
    </Stack>
  );
};

export default FlashCardContainer;
